export default "__VITE_ASSET__E1EdV6h6__"